import React from 'react';

const Training = ({children}) => {
  return (
    <div className="Training">
      { children }
    </div>
  )
}


export default Training
